import { TYPE_SET_CHAT_PAGINATION } from "app/redux/chats/chatsTypes";


export const actionSetChatPagination = {
  type: TYPE_SET_CHAT_PAGINATION,
}
